import React from 'react';
import { Router } from '@reach/router';

import ChangePassword from 'components/pages/ChangePassword';
import ForgotPassword from 'components/pages/ForgotPassword';

import { FORGOT_PASSWORD, CHANGE_PASSWORD } from './routes';
import UserSessionRouter from './UserSessionRouter';

const AppRouter: React.FC = () => {
  return (
    <Router>
      <ForgotPassword path={FORGOT_PASSWORD} />
      <ChangePassword path={CHANGE_PASSWORD} />
      <UserSessionRouter default />
    </Router>
  );
};

export default AppRouter;
